<footer class="app-footer">
  <div class="footer-top">
    <div class="footer-col">
      <h4>Grenada Transport System</h4>
      <p>
        Official platform for vehicle, inspection and ownership
        information in Grenada.
      </p>
    </div>

    <div class="footer-col">
      <h4>Sections</h4>
      <ul>
        <li>Vehicles</li>
        <li>Inspections</li>
        <li>Owners</li>
        <li>Accidents</li>
        <li>Insurances</li>
        <li>Licenses</li>
      </ul>
    </div>

    <div class="footer-col flag-col">
      <img src="assets/imatges/grenada_flag.png" alt="Flag of Grenada">
    </div>
  </div>

  <div class="footer-bottom">
    © 2026 Government of Grenada · Ministry of Infrastructure
  </div>
</footer>
